module.exports = __webpack_public_path__ + "media/Simplify_your_service_process.4efe713e.mp4";